import regeneratorRuntime from 'regenerator-runtime';
import './Index';
import './misc/InitMap';